import { AddressType } from './address-type.model';

export const addressTypes_es: AddressType [] = [
    { id: '58', name: 'Acequia' },
    { id: '71', name: 'Alameda' },
    { id: '1', name: 'Apartado' },
    { id: '15', name: 'Atajo' },
    { id: '2', name: 'Avenida' },
    { id: '4', name: 'Bajada' },
    { id: '5', name: 'Barranco' },
    { id: '3', name: 'Barrio' },
    { id: '6', name: 'Calle' },
    { id: '10', name: 'Callejón' },
    { id: '7', name: 'Camino' },
    { id: '8', name: 'Canal' },
    { id: '12', name: 'Carretera' },
    { id: '9', name: 'Cinturón' },
    { id: '11', name: 'Costa' },
    { id: '13', name: 'Descenso' },
    { id: '14', name: 'Dique' },
    { id: '18', name: 'Escaleras' },
    { id: '20', name: 'Espigón' },
    { id: '21', name: 'Estación' },
    { id: '17', name: 'Estación de Metro' },
    { id: '72', name: 'Finca' },
    { id: '22', name: 'Fuente' },
    { id: '24', name: 'Galería' },
    { id: '69', name: 'Glorieta' },
    { id: '23', name: 'Gran Vía' },
    { id: '25', name: 'Grupo' },
    { id: '26', name: 'Habitáculo' },
    { id: '28', name: 'Jardín' },
    { id: '27', name: 'Jardines' },
    { id: '74', name: 'Ladera' },
    { id: '73', name: 'Local' },
    { id: '30', name: 'Mercado' },
    { id: '29', name: 'Mirador' },
    { id: '31', name: 'Muelle' },
    { id: '32', name: 'Nudo' },
    { id: '37', name: 'Pabellón' },
    { id: '33', name: 'Pantalán' },
    { id: '34', name: 'Parque' },
    { id: '49', name: 'Pasaje' },
    { id: '40', name: 'Paseo' },
    { id: '39', name: 'Pasillo' },
    { id: '35', name: 'Paso' },
    { id: '36', name: 'Patio' },
    { id: '43', name: 'Placeta' },
    { id: '42', name: 'Plan' },
    { id: '50', name: 'Playa' },
    { id: '41', name: 'Plaza' },
    { id: '44', name: 'Polígono' },
    { id: '47', name: 'Pórticos' },
    { id: '70', name: 'Pueblo' },
    { id: '45', name: 'Puente' },
    { id: '48', name: 'Puerta' },
    { id: '46', name: 'Puerto' },
    { id: '52', name: 'Rambla' },
    { id: '55', name: 'Riera' },
    { id: '51', name: 'Rincón' },
    { id: '19', name: 'Rompeolas' },
    { id: '53', name: 'Ronda' },
    { id: '56', name: 'Rotonda' },
    { id: '57', name: 'Salón' },
    { id: '59', name: 'Sector' },
    { id: '38', name: 'Subida' },
    { id: '60', name: 'Torrente' },
    { id: '61', name: 'Travesía' },
    { id: '63', name: 'Túnel' },
    { id: '64', name: 'Urbanización' },
    { id: '66', name: 'Vía' },
    { id: '65', name: 'Vía ferrocarril' },
    { id: '67', name: 'Viaducto' },
    { id: '68', name: 'Vial' },
    { id: '76', name: 'Zona'}
];

export const addressTypes_pt: AddressType [] = [
    { id: '58', name: 'Acéquia' },
    { id: '71', name: 'Alameda' },
    { id: '1', name: 'Apartado' },
    { id: '15', name: 'Atalho' },
    { id: '2', name: 'Avenida' },
    { id: '3', name: 'Bairro' },
    { id: '5', name: 'Barranco' },
    { id: '10', name: 'Beco' },
    { id: '31', name: 'Cais' },
    { id: '7', name: 'Caminho' },
    { id: '8', name: 'Canal' },
    { id: '51', name: 'Canto' },
    { id: '70', name: 'Casal' },
    { id: '9', name: 'Circular' },
    { id: '39', name: 'Corredor' },
    { id: '11', name: 'Costa' },
    { id: '69', name: 'Cruzamento' },
    { id: '13', name: 'Descida' },
    { id: '14', name: 'Dique' },
    { id: '18', name: 'Escadas' },
    { id: '21', name: 'Estação' },
    { id: '17', name: 'Estação de Metro' },
    { id: '12', name: 'Estrada' },
    { id: '22', name: 'Fonte' },
    { id: '24', name: 'Galeria' },
    { id: '23', name: 'Gran Vía' },
    { id: '25', name: 'Grupo' },
    { id: '26', name: 'Habitáculo' },
    { id: '28', name: 'Jardim' },
    { id: '27', name: 'Jardins' },
    { id: '74', name: 'Ladeira' },
    { id: '77', name: 'Lotamento' },
    { id: '73', name: 'Lugar' },
    { id: '55', name: 'Marginal' },
    { id: '30', name: 'Mercado' },
    { id: '29', name: 'Miradouro' },
    { id: '33', name: 'Molhe' },
    { id: '32', name: 'Nó' },
    { id: '34', name: 'Parque' },
    { id: '49', name: 'Passagem' },
    { id: '40', name: 'Passeio' },
    { id: '35', name: 'Passo' },
    { id: '36', name: 'Pátio' },
    { id: '37', name: 'Pavilhão' },
    { id: '42', name: 'Plano' },
    { id: '44', name: 'Polígono' },
    { id: '45', name: 'Ponte' },
    { id: '48', name: 'Porta' },
    { id: '47', name: 'Pórticos' },
    { id: '46', name: 'Porto' },
    { id: '41', name: 'Praça' },
    { id: '43', name: 'Praceta' },
    { id: '50', name: 'Praia' },
    { id: '20', name: 'Quebra-mar' },
    { id: '72', name: 'Quinta' },
    { id: '52', name: 'Rambla' },
    { id: '54', name: 'Rec' },
    { id: '68', name: 'Rodovia' },
    { id: '53', name: 'Ronda' },
    { id: '56', name: 'Rotunda' },
    { id: '6', name: 'Rua' },
    { id: '57', name: 'Sala' },
    { id: '59', name: 'Setor' },
    { id: '38', name: 'Subida' },
    { id: '60', name: 'Torrente' },
    { id: '61', name: 'Travessia' },
    { id: '63', name: 'Túnel' },
    { id: '64', name: 'Urbanização' },
    { id: '66', name: 'Via' },
    { id: '65', name: 'Via ferroviária' },
    { id: '67', name: 'Viaduto' },
    { id: '76', name: 'Zona'}
];

export const addressTypes_en: AddressType [] = [
    { id: '10', name: 'Alley' },
    { id: '2', name: 'Avenue' },
    { id: '50', name: 'Beach' },
    { id: '71', name: 'Boardwalk' },
    { id: '52', name: 'Boulevard' },
    { id: '45', name: 'Bridge' },
    { id: '51', name: 'Corner' },
    { id: '61', name: 'Crossing' },
    { id: '14', name: 'Dam' },
    { id: '4', name: 'Downs' },
    { id: '72', name: 'Farm' },
    { id: '28', name: 'Garden' },
    { id: '46', name: 'Harbour' },
    { id: '74', name: 'Hill' },
    { id: '40', name: 'Walk' },
    { id: '30', name: 'Market' },
    { id: '34', name: 'Park' },
    { id: '49', name: 'Passage' },
    { id: '7', name: 'Path' },
    { id: '31', name: 'Port' },
    { id: '12', name: 'Road' },
    { id: '69', name: 'Round' },
    { id: '1', name: 'Section' },
    { id: '41', name: 'Square' },
    { id: '21', name: 'Station' },
    { id: '6', name: 'Street' },
    { id: '63', name: 'Tunnel' },
    { id: '67', name: 'Viaduct' },
    { id: '29', name: 'View' }
];
